module.exports = __webpack_public_path__ + "img/index04.8e04fc8b.svg";